import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Picker from "module-common/Picker";

export default class FieldRowWithDropdown extends Component {

  static propTypes = { label: PropTypes.string };  
  
  state = {
      selected: [],
      options: this.props.options
  }

  componentWillReceiveProps(nextProps) {
      const { options } = nextProps
      if(options) this.setState(state => ({
        ...state, 
        options,
        selected: options.filter(item => item.selected) 
      }))
  }

  render() {
    const { label, className, onChange } = this.props;
    const { selected, options } = this.state
    
    return (
      <Wrapper className={className}>
        <Label>{label}</Label>
        <Colon>:</Colon>
        <TextInput>
            <Picker
                options={options}
                onSelected={item => {
                    if(item.value == -1) return
                    const { selected, options } = this.state
                    const newSelected = (() => {
                        if(item.selected) return selected.filter(existing => existing.value != item.value)
                        else return selected.concat(item)
                    })()
                    const newOptions = options.map(option => {
                        if(option.value == item.value) {
                            return {...option, selected: !item.selected}
                        } else return option
                    })
                    this.setState({...this.state, options: newOptions, selected: newSelected})
                    onChange && onChange(newSelected)
                }}
            >
                <span>
                  {selected.length == 0 && 'Select tag'}
                  {selected.length > 0 && selected.map(item => item.label).join(", ")}
                </span>
            </Picker>
        </TextInput>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
`;
const Label = styled.label`
  width: 60px;
  flex: none;
`;
const Colon = styled.div`
  margin-left: auto;
  margin-right: 14px;
`;
const TextInput = styled.div`
  width: 100%;
  padding: 1px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
`;



// WEBPACK FOOTER //
// ./src/module-bulk-sms/campaign/FieldRowWithDropdown.js